import React from 'react'

import { Alert } from '@vtex/shoreline'

import { Wrapper } from './styles'

const PanelOpenValue = () => (
  <Alert variant="warning">
    <Wrapper>Este pedido contém produto com o valor aberto.</Wrapper>
  </Alert>
)

export default PanelOpenValue
